<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 집행년월 -->
          <c-datepicker
            label="LBL0010332"
            name="year"
            type="month"
            :range="true"
            default="today"
            v-model="searchParam.years"
          />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <!-- 부서 -->
          <c-dept
            type="search"
            :editable="editable"
            label="LBLDEPT"
            name="budgetDeptCd"
            :isFirstValue="false"
            v-model="searchParam.budgetDeptCd"
          />
        </div>
      </template>
    </c-search-box>
    <!-- 연간 부서별 예산집행 목록 -->
    <c-table
      ref="table"
      title="LBL0010333"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :columnSetting="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="linkClick" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safety-health-year-budget',
  data() {
    return {
      grid: {
        columns: [
          
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            style: 'width:150px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'budgetMonth',
            field: 'budgetMonth',
            // 집행년월
            label: 'LBL0010332',
            style: 'width:100px',
            align: 'center',
            sortable: true,
            type: 'link',
          },
          {
            name: 'budgetDeptName',
            field: 'budgetDeptName',
            // 부서
            label: 'LBLDEPT',
            style: 'width:150px',
            align: 'left',
            sortable: true,
          },
          {
            name: 'sumAllAmount',
            field: 'sumAllAmount',
            // 집행 총 금액(원)
            label: 'LBL0010322',
            style: 'width:150px',
            align: 'right',
            type: 'cost',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        budgetStatusCd: 'BS00000005',
        budgetDeptCd: '',
        years: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sai.budget.result.list.url;
      this.searchParam.years = [this.$comm.getThisYear() + '-01', this.$comm.getThisYear() + '-12'] 
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "LBL0010334"; // 연간 예산집행 상세
      this.popupOptions.param = {
        budgetResultId: row ? row.budgetResultId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./budgetResultDetail.vue"}`);
      this.popupOptions.width = "80%"
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
